/**
 * When staff open the full-screen preview from a Setup step, the preview's banner offers "Exit full-screen
 * preview" back to that step instead of the client page. Kept in sessionStorage so it survives moving
 * around inside the preview, and cleared on exit or when preview is opened from anywhere else.
 */
const KEY = 'sonder:previewReturn'

export function setPreviewReturn(href: string | null) {
  try {
    if (href) window.sessionStorage.setItem(KEY, href)
    else window.sessionStorage.removeItem(KEY)
  } catch {
    /* private mode */
  }
}

export function getPreviewReturn(): string | null {
  try {
    return window.sessionStorage.getItem(KEY)
  } catch {
    return null
  }
}
